module.exports = {"id":"206273","name":"Oleg Shatov","rating":"79","photo":"./data/images/photos/3/206273.png","club":{"name":"FK Krasnodar","logo":"./data/images/clubs/FKKrasnodar.png"},"positions":["MG","AG","AD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OlegShatov0.json
// module id = 3262
// module chunks = 0